export default {"src":"/encomendas-static/_next/static/media/package-icon.7a7647cb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};